import { api } from './api';

/** Applicant-safe flat projection. Canonical values are display data, not drafts. */
export interface IdentityAnnotationField {
  field: string;
  label: string;
  submittedValue: string | null;
  authoritativeValue: string | null;
  isDifferent: boolean;
  displayCopy: string | null;
  source: IdentityAnnotationSource;
}

export type IdentityAnnotationSource =
  | string
  | { sourceType?: string; sourceLabel?: string; appliedAt?: string }
  | null;

export interface IdentityAnnotations {
  identityApplied: boolean;
  notice: { kind: string; text: string } | null;
  fields: IdentityAnnotationField[];
  source: IdentityAnnotationSource;
}

export function identityAnnotations(id: string | number) {
  return api<IdentityAnnotations>(`/applications/${id}/identity-annotations`);
}